import { render, staticRenderFns } from "./TrackingNotificationLogs.vue?vue&type=template&id=9c4b1be2&"
import script from "./TrackingNotificationLogs.vue?vue&type=script&lang=js&"
export * from "./TrackingNotificationLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports